const vantaggi = [
  {
    icon: 'ri-walk-line',
    title: 'Portamento',
    desc: 'Impara a muoverti con grazia ed eleganza. Il portamento è il tuo biglietto da visita: lavoriamo sulla postura, sul passo e sulla presenza scenica che cattura ogni sguardo.',
    gradient: 'from-yellow-900/30 to-transparent',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Modelling',
    desc: 'Scopri le tecniche professionali del modelling, dalla posa in passerella alle shooting fotografiche. Formiamo modelli e modelle con gli standard richiesti dalle agenzie internazionali.',
    gradient: 'from-yellow-900/30 to-transparent',
  },
  {
    icon: 'ri-film-line',
    title: 'Recitazione',
    desc: 'Libera la tua capacità espressiva attraverso metodi di recitazione professionali. Dal monologo alla scena drammatica, svilupperemo la tua voce, il tuo corpo e la tua emozione.',
    gradient: 'from-yellow-900/30 to-transparent',
  },
  {
    icon: 'ri-movie-2-line',
    title: 'Cinema',
    desc: 'Preparati a recitare davanti alla macchina da presa. Tecniche specifiche per il cinema, comprensione del copione, emozioni autentiche e la capacità di brillare sul grande schermo.',
    gradient: 'from-yellow-900/30 to-transparent',
  },
];

const highlights = [
  { icon: 'ri-medal-line', text: 'Oltre 20 anni di esperienza nel settore' },
  { icon: 'ri-group-line', text: 'Insegnanti professionisti attivi nel settore' },
  { icon: 'ri-heart-line', text: 'Percorsi personalizzati su ogni allievo' },
  { icon: 'ri-shield-star-line', text: 'Garanzia di qualità e risultati concreti' },
];

export default function VantaggiSection() {
  return (
    <section className="py-16 md:py-28 bg-[#0D0D0D]" id="vantaggi">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <span
            className="inline-block border border-yellow-600/60 text-yellow-500 text-xs tracking-widest uppercase px-5 py-2 rounded-full mb-6"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Perché Sceglierci
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold text-white mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Da Oltre Vent'anni Diamo{' '}
            <span style={{ color: '#D4AF37' }}>Forma al Tuo Talento</span>
          </h2>
          <p
            className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed"
            style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
          >
            La nostra missione non è solo formare professionisti, ma costruire{' '}
            <span style={{ color: '#D4AF37' }}>forma, talento, presenza e sicurezza</span>{' '}
            — sia davanti alla macchina da presa che nella vita di tutti i giorni.
          </p>
        </div>

        {/* Grid Corsi */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {vantaggi.map((v) => (
            <div
              key={v.title}
              className="group relative bg-[#141414] border border-yellow-600/20 rounded-xl p-8 hover:border-yellow-500/60 transition-all duration-400 cursor-default hover:shadow-lg hover:shadow-yellow-900/30 hover:-translate-y-1"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-full bg-yellow-600/10 border border-yellow-600/30 mb-6 group-hover:bg-yellow-600/20 transition-all duration-300"
              >
                <i className={`${v.icon} text-2xl`} style={{ color: '#D4AF37' }} />
              </div>
              <h3
                className="text-xl font-bold text-white mb-3"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {v.title}
              </h3>
              <p
                className="text-gray-400 text-sm leading-relaxed"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                {v.desc}
              </p>
              <div
                className="absolute bottom-0 left-0 right-0 h-0.5 rounded-b-xl transition-all duration-300 opacity-0 group-hover:opacity-100"
                style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}
              />
            </div>
          ))}
        </div>

        {/* Highlights */}
        <div className="bg-[#141414] border border-yellow-600/20 rounded-2xl p-6 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="md:w-1/3">
              <h3
                className="text-3xl font-bold text-white mb-3"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                La Nostra{' '}
                <span style={{ color: '#D4AF37' }}>Garanzia</span>
              </h3>
              <p
                className="text-gray-400 text-sm leading-relaxed"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                Ogni allievo è seguito passo dopo passo da professionisti con grande esperienza nel settore.
              </p>
            </div>
            <div className="md:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {highlights.map((h) => (
                <div key={h.text} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                    <i className={`${h.icon} text-xl`} style={{ color: '#D4AF37' }} />
                  </div>
                  <span
                    className="text-gray-300 text-sm"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {h.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Watermark quote */}
        <p
          className="text-center mt-12 md:mt-16 text-2xl sm:text-3xl md:text-5xl font-bold tracking-widest uppercase select-none overflow-hidden"
          style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
        >
          Forma · Talento · Presenza · Sicurezza
        </p>
      </div>
    </section>
  );
}
